import InfoIcon from "@material-ui/icons/Info";
import { Divider, InputNumber, Space, Switch } from "antd";
import styled from "styled-components";

export const StyledIcon = styled(InfoIcon)`
  color: #a2aaad;
  margin-right: auto;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;

  /* Make the input right-aligned */
  > :last-child {
    margin-left: auto;
  }
`;

export const StyledSpace = styled(Space)`
  display: flex;
  flex-direction: column;
  width: 320px;
`;

export const StyledDivider = styled(Divider)`
  margin: 0;
`;

export const StyledInputContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  width: 70px;
  border-radius: var(--border-radius);
  --reset-button-width: 16px;
  --reset-button-margin: 4px;

  .ant-input-number {
    width: 100%;
    border-radius: var(--border-radius);
  }

  .ant-input-number-input {
    padding-right: calc(
      var(--reset-button-width) + var(--reset-button-margin)
    ) !important;
    border-radius: var(--border-radius);
  }
`;

export const StyledResetButton = styled.button`
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 2px;
  color: #8c8c8c;
  position: absolute;
  right: var(--reset-button-margin);
  font-size: 1rem;
  user-select: none;
  z-index: 10;
  width: var(--reset-button-width);

  &:hover {
    color: var(--color-primary);
  }

  &:active {
    color: var(--color-primary);
  }
`;

export const RightSwitch = styled(Switch)`
  margin-left: auto;
`;
export const StyledInput = styled(InputNumber)`
  width: 70px;
  border-radius: var(--border-radius);
`;
